<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách bàn giao thiết bị Tingbox</h1>
      <div class="btn-group float-right">
        <button
          type="button"
          class="font-medium f12 btn btn-outline-secondary"
          @click="exportExcel()"
        >
          <i class="bx bx-download"></i> Xuất file
        </button>
        <DraggableTable naming="gpsdfsd-a23" v-model="fieldsTable" @change="filterTable = $event" />
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.serial"
              @keypress.enter="submitForm"
              class="form-control f12 hc-37 text-search"
              placeholder="Serial thiết bị"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.categoryId"
              :options="optionType"
              placeholder="Tên thiết bị"
            ></Select2>
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.key"
              @keypress.enter="submitForm"
              class="form-control f12 hc-37 text-search"
              placeholder="Serial/Mã HĐ-PL"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.statusHandovers"
              :options="Config.getSearch(Config.statusHandoverList)"
              placeholder="Tình trạng bàn giao"
              :settings="{
                multiple: true,
                containerCssClass: 'select2-container--nowrap',
                selectionCssClass: 'select2-selection--nowrap',
              }"
              class="custom-select2"
            />
          </div>
          <!-- <div class="form-group">
            <Select2
              v-model="search.statusExport"
              :options="Config.getSearch(Config.statusExportDevice)"
              placeholder="Trạng thái xuất thiết bị"
            />
          </div> -->
          <div class="form-group">
            <Select2
              v-model="search.statusContract"
              :options="Config.getSearch(Config.listStatusContract)"
              placeholder="Trạng thái HĐ/PL"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.statusReceipt"
              :options="Config.getSearch(Config.stateReceipt)"
              placeholder="Trạng thái phiếu thu"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.typeExport"
              :options="Config.getSearch(Config.typeExportHandoverList)"
              placeholder="Loại xuất"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="search.createdTime"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Ngày tạo hợp đồng
                  <!-- Thời gian -->
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="search.dateSendDevice"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Ngày bàn giao
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="search.dateHandover"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Ngày duyệt bàn giao
                  <!-- Thơi gian bàn giao -->
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.warehouseManagement"
              :settings="settingSearch"
              placeholder="Quản lý kho"
            />
          </div>
          <div class="form-group">
            <Select2 v-model="search.storekeeper" :settings="settingSearch" placeholder="Thủ kho" />
          </div>
          <div class="form-group form-group-action">
            <button type="button" class="btn btn-primary hc-37 mr-2 pt-2" @click="submitForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button type="button" class="btn btn-outline-light hc-37 mr-2 pt-2" @click="removeForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
            <button
              type="button"
              class="btn btn-success hc-37 mr-2 pt-2"
              @click="openApproveModal()"
              :disabled="!idsSelected.length"
            >
              <i class="bx bx-message-square-add"></i><span>&nbsp;</span>Duyệt
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div class="d-flex justify-content-between align-items-center">
              <div
                v-if="hasDefaultFilter"
                class="mb-2 d-inline-flex align-items-center"
                style="
                  background-color: #fff3e0;
                  padding: 6px 12px;
                  border-radius: 4px;
                  font-size: 13px;
                "
              >
                <i class="bx bx-info-circle mr-1" style="color: #f57c00"></i>
                <span style="color: #e65100">Đang lọc mặc định 3 ngày gần nhất</span>
                <button
                  @click="removeDefaultFilter"
                  type="button"
                  class="ml-2 btn-close-filter"
                  style="
                    background: none;
                    border: none;
                    cursor: pointer;
                    padding: 0 4px;
                    color: #e65100;
                    font-size: 16px;
                    line-height: 1;
                  "
                  title="Bỏ lọc"
                >
                  ×
                </button>
              </div>
              <div>
                Tổng:
                <strong class="text-primary">{{ pagination.total }}</strong>
              </div>

              <div
                v-show="idsSelected.length"
                @click="onClearSelect"
                class="text-nowrap ml-auto text-primary cursor-pointer clean-select"
                v-b-tooltip.hover
                :title="`Click để bỏ chọn, chọn tối đa ${maxtSelect}`"
              >
                Đã chọn:
                <strong class="text-danger">{{
                  idsSelected.length.toLocaleString('vi-VN')
                }}</strong>
              </div>
            </div>

            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>

              <template #empty>
                <div class="my-2 text-center">Không có dữ liệu</div>
              </template>

              <template #head(checkbox)>
                <b-form-checkbox
                  v-model="selectAll"
                  @change="toggleSelectAll"
                  :disabled="tbLoading || selectableItems.length === 0"
                />
              </template>
              <template #cell(checkbox)="{ item }">
                <b-form-checkbox
                  v-model="item.checked"
                  @change="toggleSelectOne(item)"
                  :disabled="item.statusHandover !== 'WAIT_APPROVE'"
                />
              </template>
              <template #cell(categoryName)="data">
                {{ data.item.categoryName }}
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(serial)="data">
                {{ data.item.serial }}
              </template>
              <template #cell(contractCode)="data">
                {{ data.item.contractCode }}
              </template>
              <template #cell(handoverTime)="data">
                {{ data.item.handoverTime | formatDate('DD/MM/YYYY HH:mm:ss') }}
              </template>
              <template #cell(merchant)="data">
                <div>{{ data.item.merchantName }}</div>
                <div>{{ data.item.merchantEmail }}</div>
                <div>{{ data.item.merchantAddress }}</div>
                <div>{{ data.item.merchantMobile }}</div>
              </template>
              <template #cell(contractStatus)="data">
                <span class="badge" :class="data.item.contractStatus">
                  {{ data.item.contractStatus | transformData(Config.listStatusContract) }}
                </span>
              </template>
              <template #cell(receiptStatus)="data">
                <span class="badge" :class="data.item.receiptStatus">
                  {{ data.item.receiptStatus | transformData(Config.stateReceipt) }}
                </span>
              </template>
              <template #cell(statusHandover)="data">
                <span class="badge" :class="data.item.statusHandover">
                  {{ data.item.statusHandover | transformData(Config.statusHandoverList) }}
                </span>
              </template>
              <template #cell(typeExport)="data">
                <span>
                  {{ data.item.typeExport | transformData(Config.typeExportHandoverList) }}
                </span>
              </template>
              <template #cell(images)="data">
                <div class="d-flex flex-wrap" v-viewer>
                  <div
                    v-for="(image, index) in data.item.images"
                    :key="index"
                    href="javascript:void(0)"
                    style="cursor: pointer"
                  >
                    <img
                      :src="image"
                      alt="image"
                      style="
                        width: 80px;
                        height: 80px;
                        border-radius: 5px;
                        margin-bottom: 5px;
                        object-fit: cover;
                        margin-right: 5px;
                        border: 1px solid #ccc;
                      "
                    />
                  </div>
                </div>
              </template>
              <template #cell(action)="data">
                <b-link
                  v-if="
                    dataPermission.includes('CNPS_SCON_APPENDIX_CONFIRM_HANDOVER_DEVICE') &&
                    data.item.typeExport !== 'ECOMMERCE'
                  "
                  style="color: #0056f6"
                  size="sm"
                  @click="confirmSentEmail(data.item)"
                >
                  <img
                    src="@/assets/img/circle-three-dots.svg"
                    alt="Circle with Three Dots"
                    style="width: 15px; height: 15px"
                  />
                  Chi tiết
                </b-link>

                <!-- <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item

                    ><span>&nbsp;</span>Chi tiết
                  </b-dropdown-item>
                </b-dropdown> -->
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <!-- confirm -->
    <b-modal ref="modal-confirm" title="Xác nhận bàn giao" @hide="closeDetail">
      <div v-if="selectedItem !== null">
        <p style="font-size: 14px">
          Đây là các thiết bị trong HĐ của
          <b>{{ selectedItem.merchantEmail }}</b
          >. Bạn vui lòng kiểm tra lại trước khi xác nhận bàn giao!
        </p>
        <b-table
          class="mt-2"
          striped
          hover
          :items="selectedItem?.listDevice?.devices"
          :fields="tableFields"
        >
          <template #cell(price)="data">
            <div>
              {{ data.item.price | transformMoney }}
            </div>
          </template>
        </b-table>

        <div
          class="scroll-list"
          v-if="!['WAIT_APPROVE', 'SUCCESS'].includes(selectedItem.statusHandover)"
        >
          <UploadMultiple2
            :imagesPreview="images"
            :title="'Ảnh xác nhận bàn giao'"
            :maxFile="100"
            titleTag="h2"
            :uploadToApi="false"
            :isDragging="true"
            titleClass="form-inner-heading"
            ref="uploadImages"
          />

          <div class="mt-3 mr-2">
            <h2 class="form-inner-heading">
              File xác nhận bàn giao
              <sup
                class="text-danger"
                v-show="PROVIDER_NEED_UPLOAD_FILE.includes(selectedItem.provider)"
                >*</sup
              >
            </h2>
            <div
              class="d-flex flex-column align-items-center justify-content-center cursor-pointer"
              @click="$refs.fileInput.click()"
              :class="{ 'border-success': selectedItem?.listDevice?.files?.length > 0 }"
              style="
                border: 1px dashed #007bff;
                border-radius: 8px;
                padding: 10px;
                background: #ebf5ff;
              "
            >
              <i class="bx bx-upload text-primary" style="font-size: 24px"></i>
              <span class="text-secondary text-center mt-2 text-truncate w-100">{{
                selectedFile
                  ? selectedFile.name
                  : selectedItem?.listDevice?.files?.[0]
                    ? selectedItem?.listDevice?.files?.[0].split('/').pop()
                    : 'Chọn file xác nhận bàn giao (.pdf)'
              }}</span>
              <input
                type="file"
                ref="fileInput"
                class="d-none"
                accept=".pdf"
                @change="handleFileUpload"
              />
            </div>
          </div>

          <b-button class="mt-2" variant="primary" :disabled="!isEnableSave" @click="upImage"
            >Lưu ảnh</b-button
          >
        </div>

        <div class="scroll-list" v-else>
          <div v-if="selectedItem?.listDevice?.images?.length > 0">
            <div class="img-list">
              <ul v-viewer class="m-0">
                <li
                  class="p-1 item-img"
                  v-for="(item, index) in selectedItem?.listDevice?.images"
                  :key="index"
                >
                  <a href="javascript:void(0)">
                    <img :src="item" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div v-if="selectedItem?.listDevice?.files?.length > 0">
            <ul v-viewer class="m-0">
              <li
                class="p-1 item-img"
                v-for="(item, index) in selectedItem?.listDevice?.files"
                :key="index"
              >
                <a :href="`/viewer/pdf?url=${encodeURIComponent(item)}`" target="_blank">
                  <b-icon icon="file-pdf"></b-icon> {{ item.split('/').pop() }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        class="mt-2 font-size-14"
        v-if="selectedItem?.listDevice?.reasons && selectedItem?.listDevice?.reasons?.length"
      >
        <span class="font-bold">Lý do từ chối: </span>
        <span>
          {{
            selectedItem?.listDevice?.reasons[selectedItem?.listDevice?.reasons?.length - 1].reason
          }}</span
        >
      </div>
      <template #modal-footer>
        <div
          v-if="selectedItem.statusHandover !== 'WAIT_APPROVE'"
          class="d-flex justify-content-end"
        >
          <b-button @click="$refs['modal-confirm'].hide()" variant="light">Bỏ qua</b-button>
          <b-button
            :disabled="disableBtn"
            class="ml-2"
            variant="primary"
            @click="sendEmail(selectedItem)"
            >Xác nhận</b-button
          >
        </div>
        <div v-else class="d-flex justify-content-end">
          <div v-if="dataPermission.includes('CNPS_SCON_APPENDIX_CONFIRM_HANDOVER_DEVICE')">
            <b-button variant="danger" @click="reject()">Từ chối</b-button>
            <b-button class="ml-2" variant="success" @click="handleApprove(selectedItem)">
              Duyệt
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
    <b-modal id="modal-scoped" v-model="showModal" @hide="handleCloseReject">
      <template #modal-header="{ close }">
        <h5>Bạn chắc chắn muốn từ chối bàn giao thiết bị?</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="">
        <p class="f14 pb-2">Lý do từ chối yêu cầu</p>
        <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
          <form @submit.prevent="handleSubmit(handleReject)">
            <ValidationProvider rules="required|minMaxName_4" name="Lý do" v-slot="{ errors }">
              <b-form-group label="" label-for="floatingTextarea2">
                <b-form-textarea
                  id="floatingTextarea2"
                  v-model="reason"
                  placeholder="Lý do"
                  rows="3"
                  max-rows="6"
                  :state="errors.length > 0 ? false : null"
                >
                </b-form-textarea>
                <b-form-invalid-feedback id="input-live-feedback">{{
                  errors[0]
                }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
          </form>
        </ValidationObserver>
      </div>
      <template #modal-footer="{ close }">
        <b-button size="sm" variant="light" @click="close()"> Huỷ bỏ </b-button>
        <b-button size="sm" variant="primary" @click="handleReject"> Đồng ý </b-button>
      </template>
    </b-modal>

    <!-- Modal xác nhận duyệt nhiều  -->
    <PopupComfirm ref="popupComfirmTingboxRef" @onLoad="reLoadData" />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import cloneDeep from 'lodash/cloneDeep'
  import { DeviceService } from '../../../services/device.service'
  import moment from 'moment'
  import { ContractService } from '@/services/contract.service'
  import UploadMultiple2 from '@/components/cskh/UploadMultiple2.vue'
  import PopupComfirm from './components/PopupComfirm.vue'
  import { SearchStaff } from '@/services/customer-support/staff'
  import { getLastNDays } from '@/utils/util'
  import { CommonService } from '@/services/common.service'

  const PROVIDER_NEED_UPLOAD_FILE = ['NGAN_LUONG', 'SHARED']

  const fieldsTable = [
    {
      key: 'checkbox',
      label: 'checkbox',
      sortable: false,
      thStyle: 'width: 30px; text-align: center',
    },
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'categoryName', label: 'Tên thiết bị' },
    { key: 'serial', label: 'Serial TB' },
    { key: 'contractCode', label: 'Mã HĐ/PL', thStyle: 'min-width: 120px' },
    { key: 'merchant', label: 'Merchant', thStyle: 'min-width: 170px' },
    { key: 'keeperName', label: 'Thủ tho', thStyle: 'min-width: 170px' },
    { key: 'managerName', label: 'Quản lý kho', thStyle: 'min-width: 170px' },
    {
      key: 'contractStatus',
      label: 'Trạng thái HĐ/PL',
    },
    {
      key: 'receiptStatus',
      label: 'Trạng thái Phiếu thu',
    },
    {
      key: 'statusHandover',
      label: 'Tình trạng bàn giao',
    },
    {
      key: 'typeExport',
      label: 'Loại xuất',
    },
    {
      key: 'handoverTime',
      label: 'Thời gian bàn giao',
    },
    {
      key: 'images',
      label: 'Ảnh xác nhận bàn giao',
      thStyle: 'min-width: 200px',
    },

    {
      key: 'action',
      label: 'Thao tác',
      fixIndex: 999,
      class: 'text-center',
      thStyle: 'min-width: 80px',
    },
  ]

  const searchFormInit = {
    categoryId: '',
    key: '',
    limit: 20,
    page: 1,
    serial: '',
    statusHandovers: [],
    statusContract: '',
    statusReceipt: '',
    // statusExport: '',
    warehouseManagement: '',
    storekeeper: '',
    createdTime: {
      startDate: null,
      endDate: null,
    },
    dateHandover: {
      startDate: null,
      endDate: null,
    },
    dateSendDevice: {
      startDate: null,
      endDate: null,
    },
  }

  export default {
    name: 'ticket',
    components: { UploadMultiple2, PopupComfirm },
    data() {
      const { from, to } = getLastNDays(3, 'date')
      const initSearch = cloneDeep(searchFormInit)
      initSearch.createdTime.startDate = from
      initSearch.createdTime.endDate = to
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        lists: [],
        showLoading: false,
        tbLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataManager: [],
        dataConfigRegion: [],
        dataTypeCode: [],
        dataSubTypeCode: [],
        showModal: false,
        disableBtn: true,
        reason: '',
        itemChoose: null,
        optionType: [],
        search: initSearch,
        pagination: {
          total: 0,
        },
        idsSelected: [],
        selectAll: false,
        maxtSelect: 0,
        images: [],
        selectedItem: null,
        hasDefaultFilter: true,
        tableFields: [
          { key: 'name', label: 'Tên thiết bị' },
          { key: 'serialNumber', label: 'Serial' },
          { key: 'price', label: 'Giá' },
        ],
        settingSearch: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }

              if (this.tLoadAccount) {
                clearTimeout(this.tLoadAccount)
              }
              this.tLoadOwner = setTimeout(() => {
                SearchStaff({
                  limit: 50,
                  // page: 1,
                  keyWord: txtSearch,
                })
                  .then(res => {
                    success({
                      results:
                        res.data?.map(item => {
                          return {
                            id: item?.id,
                            text: (item?.name || item?.userName) ?? item?.email,
                          }
                        }) || [],
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },

        // upload file
        selectedFile: null,
        PROVIDER_NEED_UPLOAD_FILE,
      }
    },
    watch: {
      'search.page': function () {
        this.fetchData()
      },
      // images: {
      //   handler: function (value) {
      //     console.log('images', value)
      //   },
      // },
    },
    async created() {
      this.search.statusHandovers = ['UNSENT']
      await this.typeDeviceConfig()
      await this.fetchData()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      selectableItems() {
        return this.lists.filter(item => item.statusHandover === 'WAIT_APPROVE')
      },

      isEnableSave() {
        if (!this.selectedItem) return false
        if (
          PROVIDER_NEED_UPLOAD_FILE.includes(this.selectedItem.provider) &&
          !this.selectedFile &&
          !this.selectedItem?.listDevice?.files?.[0]
        ) {
          return false
        }
        return this.images.length > 0
      },
    },
    methods: {
      async exportExcel() {
        const params = this.preareData()
        try {
          this.showLoading = true
          await DeviceService.dowTemplateTingbox({ ...params, typeDevice: 'TINGBOX' })
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },

      closeDetail() {
        this.images = []
        this.disableBtn = true
      },

      // Mở modal approve
      openApproveModal() {
        this.$refs.popupComfirmTingboxRef.show(this.idsSelected)
      },

      async upImage() {
        try {
          if (this.images.length < 1) {
            this.showFailMx('Bạn cần chọn ít nhất một ảnh.')
            return
          }
          this.showLoading = true

          // upload images
          const images = await this.$refs.uploadImages.saveData()

          // upload file
          let fileUrl = this.selectedItem?.listDevice?.files?.[0] || ''
          if (this.selectedFile) {
            try {
              const formData = new FormData()
              formData.append('files', this.selectedFile)
              formData.append('folderName', 'NextCrm')
              const uploadResponse = await CommonService.uploadFile(formData)
              if (uploadResponse.code === 1000) {
                fileUrl = uploadResponse.data[0]
                this.selectedItem.listDevice.files = [fileUrl]
                this.selectedFile = null
              }
            } catch (error) {
              console.error(error)
              this.showFailMx(error.message || 'Lỗi upload file')
              this.loading = false
              return
            }
          }

          const params = {
            contractId: this.selectedItem.contractId,
            contractCode: this.selectedItem.contractCode,
            contractType: this.selectedItem.contractType,
            images,
            files: [fileUrl],
          }
          const response = await DeviceService.updateImageHandoverDevice(params)
          if (response.code === 1000) {
            // await this.fetchData()
            this.showSuccessMx(response.message)
            this.showLoading = false
            this.disableBtn = false
            // this.selectedItem.listDevice = response.data.data
            // this.selectedFile = null
          } else {
            this.showFailMx(response.message ?? response.error)
          }
          if (this.images.length === 0) {
            this.disableBtn = true
          }
        } catch (e) {
          this.showFailMx(e.response?.data?.message ? e.response.data.message : e.message)
        } finally {
          this.showLoading = false
        }
        return await this.$refs.uploadImages.saveData()
      },
      handleCloseReject() {
        this.reason = ''
      },
      reject() {
        this.showModal = true
      },
      toggleSelectAll() {
        const value = this.selectAll
        for (const item of this.lists) {
          // Chỉ toggle cho các item không phải WAIT_APPROVE
          if (item.statusHandover === 'WAIT_APPROVE') {
            item.checked = value
            const index = this.idsSelected.findIndex(selected => selected.id === item.id)
            index >= 0 && this.idsSelected.splice(index, 1)
            if (value) {
              !this.idsSelected.some(selected => selected.id === item.id) &&
                this.idsSelected.push(item)
            }
          }
        }
        this.cleanSelectIfOver()
      },

      cleanSelectIfOver() {
        this.idsSelected.length > this.maxtSelect &&
          (() => {
            this.idsSelected = this.idsSelected.slice(this.maxtSelect)
          })()
      },

      onClearSelect() {
        this.idsSelected = []
        this.selectAll && (this.selectAll = false)
        this.lists.forEach(item => {
          // Chỉ clear checkbox cho các item WAIT_APPROVE
          if (item.statusHandover === 'WAIT_APPROVE') {
            item.checked && (item.checked = false)
          }
        })
      },

      toggleSelectOne(item) {
        // Nếu item có trạng thái WAIT_APPROVE thì không xử lý
        if (item.statusHandover !== 'WAIT_APPROVE') {
          return
        }

        const index = this.idsSelected.findIndex(selected => selected.id === item.id)
        index >= 0 && this.idsSelected.splice(index, 1)
        if (item.checked) {
          !this.idsSelected.some(selected => selected.id === item.id) && this.idsSelected.push(item)
        }
        // Chỉ check selectAll nếu tất cả các item có thể select đều được chọn
        this.selectAll = this.selectableItems.every(item => item.checked)
        this.cleanSelectIfOver()
      },

      handleApprove(item) {
        const modal = this.approveMx('Bạn chắc chắn muốn duyệt bàn giao thiết bị?')
        modal.then(async close => {
          if (close) {
            await this.confirmHandover('Duyệt bàn giao thiết bị', {
              action: 'SUCCESS',
              contractId: item.contractId,
              contractType: item.contractType,
            })
            // this.handleBack()
          }
        })
      },

      async handleReject() {
        // validate reason
        const isValid = await this.$refs.observer.validate()
        if (!isValid) return
        this.showModal = false
        await this.confirmHandover('Duyệt bàn giao thiết bị', {
          action: 'REJECTED',
          contractId: this.selectedItem.contractId,
          contractType: this.selectedItem.contractType,
          reason: this.reason,
        })
        this.$refs['modal-confirm'].hide()
      },

      async confirmHandover(text, params) {
        try {
          this.showLoading = true
          const response = await ContractService.confirmHandleHandover(params)
          if (response.success) {
            await this.fetchData()
            this.showSuccessMx(text + ' thành công')
            this.$refs['modal-confirm'].hide()
          } else {
            this.showFailMx(response.message ?? response.error)
          }
        } catch (error) {
          this.showFailMx(error)
        } finally {
          this.showLoading = false
        }
      },

      async submitForm() {
        this.search.page = 1
        this.fetchData()
      },
      reLoadData() {
        this.idsSelected = []
        this.search.page = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = cloneDeep(searchFormInit)
        this.idsSelected = []
        this.search.createdTime = {
          startDate: null,
          endDate: null,
        }
        this.search.dateHandover = {
          startDate: null,
          endDate: null,
        }
        this.hasDefaultFilter = false
        await this.fetchData()
      },

      removeDefaultFilter() {
        this.hasDefaultFilter = false
        this.idsSelected = []
        this.search.page = 1
        this.search.createdTime = { startDate: null, endDate: null }
        this.fetchData()
      },
      async typeDeviceConfig() {
        try {
          const data = await DeviceService.typeDeviceConfig()
          if (data.success) {
            this.optionType = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.optionType.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          this.showFailMx(error.message || error.response.message || 'Đã có lỗi xảy ra')
        }
      },

      checkDataZero(value) {
        if (value === '0') return ''
        else return value
      },

      preareData() {
        const params = cloneDeep(this.search)

        if (params.createdTime.endDate) {
          params.dateFrom = moment(params.createdTime.startDate).startOf('day').valueOf()
          params.dateTo = moment(params.createdTime.endDate).endOf('day').valueOf()
        }
        delete params.createdTime

        if (params.dateHandover.endDate) {
          params.dateHandoverFrom = moment(params.dateHandover.startDate).startOf('day').valueOf()
          params.dateHandoverTo = moment(params.dateHandover.endDate).endOf('day').valueOf()
        }
        delete params.dateHandover

        if (params.dateSendDevice.endDate) {
          params.dateSendHandoverFrom = moment(params.dateSendDevice.startDate)
            .startOf('day')
            .valueOf()
          params.dateSendHandoverTo = moment(params.dateSendDevice.endDate).endOf('day').valueOf()
        }
        delete params.dateSendDevice

        // if (!params.statusExport || params.statusExport === '0') {
        //   delete params.statusExport
        // }
        params.statusHandovers = params.statusHandovers?.filter(item => item !== '0')

        params.typeExport = this.checkDataZero(params.typeExport)
        params.categoryId = this.checkDataZero(params.categoryId)
        params.statusReceipt = this.checkDataZero(params.statusReceipt)
        params.statusContract = this.checkDataZero(params.statusContract)

        return params
      },

      async fetchData() {
        try {
          this.tbLoading = true
          if (this.search.statusContract || this.search.statusReceipt) {
            if (this.search.createdTime.endDate === null) {
              this.showFailMx(
                'Bạn cần chọn ngày tạo hợp đồng, nếu muốn tìm kiếm theo trạng thái hợp đồng hoặc phiếu thu'
              )
              return
            }
          }

          const params = this.preareData()

          const response = await DeviceService.getListDevideHandover({
            ...params,
            typeDevice: 'TINGBOX',
          })
          if (response.code === 1000) {
            // Lấy danh sách mới
            const newLists = response.data.devices ? response.data.devices : []

            // Đồng bộ trạng thái checked với các item đã được chọn trước đó
            this.lists = newLists.map(item => {
              const selectedItem = this.idsSelected.find(selected => selected.id === item.id)
              if (selectedItem) {
                return {
                  ...item,
                  checked: true,
                }
              }
              return {
                ...item,
                checked: false,
              }
            })

            this.pagination.total = response.data.count ? response.data.count : 0
            this.maxtSelect = response.data.count ? response.data.count : 0

            // Cập nhật lại trạng thái selectAll
            if (this.lists.length > 0) {
              const selectableItems = this.lists.filter(
                item => item.statusHandover === 'WAIT_APPROVE'
              )
              this.selectAll =
                selectableItems.length > 0 && selectableItems.every(item => item.checked)
            } else {
              this.selectAll = false
            }
          } else {
            this.lists = []
            this.showFailMx(response.message ?? response.error)
          }
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message ?? error)
        } finally {
          this.tbLoading = false
        }
      },

      async confirmSentEmail(item) {
        try {
          this.selectedItem = null
          this.showLoading = true
          const params = {
            contractId: item.contractId, // ==> Id HĐ/PL (Bắt buộc)
            contractCode: item.contractCode, //= => Mã HĐ/PL (K bắt buộc)
            contractType: item.contractType, //= => Kiểu (CONTRACT / APPENDIX)
          }
          const response = await DeviceService.getDeviceInContract(params)
          if (response.code === 1000) {
            this.showLoading = false
            item.listDevice = response.data
            this.selectedItem = item
            if (response.data.images && response.data.images.length > 0) {
              this.images = response.data.images
              this.disableBtn = false
            }
            this.$refs['modal-confirm'].show()
            this.selectedFile = null
          } else {
            this.showFailMx(response.message ?? response.error)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },

      async sendEmail(item) {
        try {
          this.showLoading = true
          const params = {
            contractId: item.contractId, // ==> Id HĐ/PL (Bắt buộc)
            contractCode: item.contractCode, //= => Mã HĐ/PL (K bắt buộc)
            contractType: item.contractType, //= => Kiểu (CONTRACT / APPENDIX)
          }
          const response = await DeviceService.sendConfirmHandover(params)
          if (response.code === 1000) {
            this.fetchData()
            this.showSuccessMx(response.message)
            this.showLoading = false
            this.$refs['modal-confirm'].hide()
          } else {
            this.showFailMx(response.message ?? response.error)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      async handleFileUpload(event) {
        const file = event.target.files[0]
        if (!file) return
        this.selectedFile = file
        this.$refs.fileInput.value = ''
      },
    },
  }
</script>

<style scoped>
  .badge {
    color: white;
  }

  .DONE,
  .ACTIVE,
  .SUCCESS {
    background-color: #007bff;
  }

  .PENDING_APPROVAL,
  .PENDING_CONFIRM_APPROVAL {
    background-color: #ffc107;
  }

  .CANCEL,
  .REJECTED {
    background-color: #dc3545;
  }

  .UNSENT {
    color: black;
    background-color: #c7c7c7;
  }

  .SEND {
    background-color: #1a9e3f;
  }

  .scroll-list {
    position: relative;
    max-height: 50vh;
    overflow-y: scroll;
  }
</style>
